import { HttpHeaders } from '@angular/common/http';
import { LibConfig } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';
import { environment } from 'src/environments/environment';
import { EndpointResource } from './endpoint_conf';

const APPLICATION_ID = 'app';
const LEVEL_ID = 'NA';

export const LIB_CONF: LibConfig = {
  apiUrl: '',
  usesSessionTokenApi: true,
  publicKey: environment.public_key,
  applicationId: APPLICATION_ID,
  levelid: LEVEL_ID,
  secureLocalStorage: false,
  secureStorageBackend: 'indexedDB',
  useHttpOnlyCookies: true,
  useForceHeader: true,
  // Ojo: la exclusión solo aplica al interceptor. resolveSignatureToken( .. ) mira
  // el flag global, así que este endpoint igual se firma con token vacío.
  excludedEndpointsCookies: [EndpointResource.sessionEndpoint],
  csrfCookieName: 'webToken',
  refreshWithCookies: false,
};

// v1.0.0 dejó de enviar `applicationid`; se repone por request.
export const LIB_HEADERS = new HttpHeaders({ applicationid: APPLICATION_ID });
